import axios from "../Constants/axios.js";
import { setToken } from "../helper/storage.js";
import { clearUser } from "../Redux/slices/userSlice.js";
import { errorToast, successToast } from "./Toast.js";

export const url = {
  signIn: "/api/auth/signIn",
  register: "/api/auth/register",
  requestPasswordReset: "/api/auth/requestPasswordReset",
  PasswordReset: "/api/auth/resetPassword",
  validateToken: "/api/auth/validateToken",
  contact: "/api/auth/contact",
};

export const SendContactForm = ({ name, email, message, subject }) => {
  return axios.post(url.contact, {
    name,
    email,
    message,
    subject,
  });
};

export const signUpAsync = async ({ email, password }) => {
  return axios.post(url.register, {
    username: email,
    password: password,
  });
};

export const signInAsync = async ({ email, password }) => {
  try {
    const response = await axios.post(url.signIn, {
      username: email,
      password,
    });

    if (response.data.token) {
      setToken("USER_KEY", response.data.token);
      successToast(response.data.message);
      return response.data;
    } else {
      throw new Error("Token not received");
    }
  } catch (error) {
    console.error("Error signing in:", error);
    errorToast(error.response ? error.response.data : "Unknown error");
    throw new Error(error.response ? error.response.data : "Unknown error");
  }
};

export const logUserOut = (dispatch) => {
  localStorage.removeItem("USER_KEY");
  dispatch(clearUser());
  window.location = "/signin";
};
